import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SEOFormType, SEOInitialStateType, SlugFormType } from 'features/Product/@types/SEO'

import { fetchProductDetail, fetchSEODetail, fetchSEOOptions, updateSEO } from './thunk'

export const INITIAL_SEO_FORM: SEOFormType = {
  metaTitle: '',
  metaDescription: '',
  url: '',
  robots: {
    index: true,
    follow: true,
  },
  placeholders: [],
}

export const INITIAL_SLUG_FORM: SlugFormType = {
  currentSlug: '',
  label: '',
  domain: '',
  changes: [],
}

export const initialState: SEOInitialStateType = {
  isLoading: false,
  productId: 0,
  productDetail: null,
  formSEO: INITIAL_SEO_FORM,
  initialFormSEO: INITIAL_SEO_FORM,
  formSLUG: INITIAL_SLUG_FORM,
}

const seoSlice = createSlice({
  name: 'seo',
  initialState,
  reducers: {
    setFormSEO: (state, action: PayloadAction<Partial<SEOFormType>>) => {
      state.formSEO = {
        ...state.formSEO,
        ...action.payload,
      }
    },
    setFormSLUG: (state, action: PayloadAction<Partial<SlugFormType>>) => {
      state.formSLUG = {
        ...state.formSLUG,
        ...action.payload,
      }
    },
    resetSEO: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSEODetail.pending, (state, action) => {
        state.isLoading = true
        state.productId = action.meta.arg
      })
      .addCase(fetchSEODetail.fulfilled, (state, action) => {
        state.isLoading = false
        state.formSEO = {
          ...state.formSEO,
          ...action.payload.form,
        }
        // recommendation present => refresh slug form; null => no pending changes, clear it.
        state.formSLUG = action.payload.slug ?? INITIAL_SLUG_FORM
        // snapshot loaded values as baseline for change detection.
        state.initialFormSEO = state.formSEO
      })
      .addCase(fetchSEODetail.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(fetchProductDetail.fulfilled, (state, action) => {
        state.productDetail = action.payload
      })
      .addCase(fetchSEOOptions.fulfilled, (state, action) => {
        state.formSEO.placeholders = action.payload
      })
      .addCase(updateSEO.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateSEO.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateSEO.rejected, (state) => {
        state.isLoading = false
      })
  },
})

export const { setFormSEO, setFormSLUG, resetSEO } = seoSlice.actions

export default seoSlice.reducer
